module.exports = __webpack_public_path__ + "img/aliexpress.d3d23b6f.png";